import Acl from '@/client/extensions/helpers/Acl.js';

export default {
  install(app) {
    const $acl = new Acl(app.store);
    app.store.commit("user/attachAclInstance", { acl : $acl, user: false });
    app.config.globalProperties.$acl = $acl;

    let addAclToInstance = (instance) => {
      if (!instance) {
        return;
      }
      instance.$acl = instance.$acl ? instance.$acl : $acl;
    };
    app.mixin({
      created() {
        addAclToInstance(this);
      },
    });

    addAclToInstance(app);
  },
}